import ApiHandler from '../ApiHandler';

const ORIGIN = {
  sourcetypeid: 1, // Agent
  platformtypeid: 3, // AgentPortal
};

class OaApiHander extends ApiHandler {
  addOrigin(data) {
    if (!!data && !Object.prototype.hasOwnProperty.call(data, 'sourcetypeid')) {
      data.sourcetypeid = ORIGIN.sourcetypeid;
    }
    if (!!data && !Object.prototype.hasOwnProperty.call(data, 'platformtypeid')) {
      data.platformtypeid = ORIGIN.platformtypeid;
    }
    return data;
  }

  get(url, data, identifier, fullResponse) {
    return super.get(url, this.addOrigin(data), identifier, fullResponse);
  }

  post(url, data, identifier, fullResponse) {
    return super.post(url, this.addOrigin(data), identifier, fullResponse);
  }

  put(url, data, identifier, fullResponse) {
    return super.put(url, this.addOrigin(data), identifier, fullResponse);
  }
}

const OaApiHandler = new OaApiHander();
export default OaApiHandler;
